export { default as Text } from './AppText'